module.exports = __webpack_public_path__ + "img/carhire_icon.f6f80c9c.svg";